<ion-content>
  <div class="h-100">
    <ion-row class="p-0 headerBreadcrumb">
      <ion-col size class="center-content">
        <div class="d-flex">
          <img src="assets/icon/backArrow.svg" class="cp" (click)="onClickback()" />
          <label class="font_semibold fs-16 fs_14ForMobile ml-10 mt-5 black_color" (click)="onClickback()">
            <span class="cp">DWMPlus</span>
            /
            <span [style.color]="buttonColorName">Setup</span>
          </label>
        </div>
      </ion-col>

      <!-- ============================ Save and Cancle button ======================== -->
      <ion-col size="auto" class="text-right">
        <div *ngIf="!userIsAdminTypes?.userIsAdmin" class="d-inline-flex p-5">
          <button (click)="onClickDWMCancle()" type="button" class="back_btn mr-10">Cancel</button>
          <button type="button" class="dwm_Btn fs-14 fs_12ForMobile mr-10" [style.background-color]="buttonColorName" (click)="saveSetupData()">Save</button>
        </div>
      </ion-col>
    </ion-row>

    <div class="modal-body">
      <!-- =============================================  Setup ===================================-->

      <div class="mt-10">
        <div class="cardBox">
          <div class="headingOfShowBox font_medium fs-14 fs_12ForMobile">
            <ion-row class="p-0">
              <ion-col size="12">
                <div class="font_bold fs-14 fs_12ForMobile ml-5">Setup</div>
              </ion-col>
            </ion-row>
          </div>
          <ion-row>
            <ion-col size="12" size-md="6">
              <!-- =============================  Fiscal Year, Year, Cut-off Date =============================== -->

              <ion-row class="mt-10 mb-10">
                <ion-col size="12" size-md="4">
                  <div class="formLabelSemiBoldfs14 mb-5">
                    Fiscal Year
                    <span class="red-cl">&nbsp;*</span>
                  </div>
                  <div class="inputBoxDisabled mw-sm-150">{{ sharedService.transform(loggedInCompanyFiscalyear) }}</div>
                </ion-col>
                <ion-col size="12" size-md="4">
                  <div class="formLabelSemiBoldfs14 mb-5">
                    Year
                    <span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
                    <mat-select placeholder="Select" [(ngModel)]="selectedYearForDWM" (selectionChange)="getYearSetupForDWM(selectedYearForDWM)" [disabled]="userIsAdminTypes?.userIsAdmin">
                      <mat-option [value]="item.year" *ngFor="let item of pmsYears">{{ sharedService.transformYearToFyFormat(item.year) }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size="12" size-md="4">
                  <div class="formLabelSemiBoldfs14 mb-5">
                    Cut-off Date
                    <span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Enter Cut-off " [(ngModel)]="cutOffDate" name="cutOffDate" min="1" max="31" required (input)="validateCutOffDate()" [disabled]="userIsAdminTypes?.userIsAdmin" />
                  </mat-form-field>
                  <div class="cutOfDate red pt-5" *ngIf="isInvalidCutOffDate">Enter Cut-off Date between 1 and 31</div>
                </ion-col>
              </ion-row>

              <!-- ============================= Set Reminder =============================== -->

              <div class="font_semibold fs-16 fs_14ForMobile mt-5 d-flex align-items-center">
                Set Reminder
                <span matTooltip="Remind user to submit their DWM for approval" matTooltipPosition="right" class="info-note-icon material-icons">info</span>
              </div>

              <!-- ========================== Set Reminder  =============================-->

              <ion-row class="mt-10">
                <ion-col size="12" size-sm="4">
                  <div class="formLabelSemiBoldfs14 mb-5">Monthly DWM</div>
                  <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Enter days(1–31)" [(ngModel)]="monthlyDwm" name="monthlyDwm" min="1" max="31" #monthlyCtrl="ngModel" [disabled]="userIsAdminTypes?.userIsAdmin" />
                  </mat-form-field>

                  <mat-error *ngIf="monthlyCtrl.invalid && monthlyCtrl.touched">Please enter a value between 1 and 31</mat-error>
                </ion-col>
                <ion-col size="12" size-sm="4">
                  <div class="formLabelSemiBoldfs14 mb-5">Annually DWM</div>
                  <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
                    <input matInput type="number" placeholder="Enter days(1–365)" [(ngModel)]="yearlyDwm" name="annually" min="1" max="365" #yearlyCtrl="ngModel" [disabled]="userIsAdminTypes?.userIsAdmin" />
                  </mat-form-field>
                  <mat-error *ngIf="yearlyCtrl.invalid && yearlyCtrl.touched">Please enter a value between 1 and 365</mat-error>
                </ion-col>
              </ion-row>

              <!-- ========================== R and D Admin & RnD Project =============================-->
              <ion-row class="mb-10">
                <ion-col col="6">
                  <div class="font_semibold fs-16 fs_14ForMobile mb-5">
                    R&D Admin
                    <span class="red-cl">&nbsp;*</span>
                  </div>
                  <mat-form-field class="w-40 mw-sm-250 mat-height40 mat-input-style">
                    <mat-select placeholder="Select R&D Admin" [(ngModel)]="selectedSubAdmin" #subAdmin="ngModel" [disabled]="userIsAdminTypes?.userIsAdmin">
                      <mat-option *ngFor="let emp of employeeList" [value]="emp">{{ emp }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="subAdmin.invalid && subAdmin.touched">Please select a R&D admin.</mat-error>
                  </mat-form-field>
                </ion-col>
              </ion-row>

              <!-- ========================== EOD Report =============================-->

              <ion-row class="mb-10">
                <ion-col size="12">
                  <div class="font_semibold fs-16 fs_14ForMobile">
                    EOD Report to be Sent
                    <span class="red-cl">&nbsp;*</span>
                  </div>
                </ion-col>
                <ion-row>
                  <ion-col size="12">
                    <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                      <input matInput [(ngModel)]="eodTime" type="time" class="font_regular fs-12" [disabled]="userIsAdminTypes?.userIsAdmin" />
                    </mat-form-field>
                  </ion-col>
                </ion-row>
              </ion-row>
            </ion-col>

            <!-- ========================== Create and Manage Categories =============================-->

            <ion-col size="12" size-md="6">
              <ion-row>
                <ion-col size="12" class="mt-10">
                  <div class="font_semibold fs-16 fs_14ForMobile">
                    Create & Manage Categories
                    <span class="red-cl">*</span>
                  </div>
                </ion-col>
                <ion-col size="12" *ngIf="!showAddCategoryInput && !userIsAdminTypes?.userIsAdmin">
                  <div class="font_semibold addnewbtn fs-14 fs_12ForMobile cp" (click)="toggleAddCategory()">+ Add New Category</div>
                </ion-col>

                <ion-col size="12" *ngIf="showAddCategoryInput && !userIsAdminTypes?.userIsAdmin">
                  <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                    <input matInput [(ngModel)]="newCategoryName" placeholder="Category" maxlength="150" class="font_regular fs-12" [disabled]="userIsAdminTypes?.userIsAdmin" />
                  </mat-form-field>

                  <div class="d-flex mt-5">
                    <div class="font_semibold addnewbtn fs-14 cp ml-10" (click)="saveAddNewCategory()">Save</div>
                    <div class="font_semibold addnewbtn ml-10 fs-14 cp bluecolor" (click)="toggleAddCategory()">Cancel</div>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row>
                <!-- ====================  Category Table ================================== -->

                <ion-col size="12">
                  <div class="table-scroll-wrapper">
                    <table class="custom-table rounded-header w-100">
                      <thead>
                        <tr>
                          <th class="font_semibold fs-14 fs_12ForMobile">Category Name</th>
                          <th class="font_semibold fs-14 fs_12ForMobile text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let data of allCategoriesList; let i = index">
                          <td>
                            <span *ngIf="!data.editable">{{ data.categoryName }}</span>
                            <mat-form-field *ngIf="data.editable" class="w-100 mw-sm-250 mat-height40 mat-input-style">
                              <input matInput [(ngModel)]="data.categoryName" placeholder="Edit Category" class="font_regular fs-12" [disabled]="userIsAdminTypes?.userIsAdmin" />
                            </mat-form-field>
                          </td>
                          <td class="text-center">
                            <ng-container *ngIf="!userIsAdminTypes?.userIsAdmin">
                              <span *ngIf="!data.editable" class="material-icons fs-20 red cp" (click)="deleteCategory(data)">delete</span>
                              <span *ngIf="!data.editable" class="material-icons fs-20 blue cp ml-5" (click)="editCategory(data)">edit</span>
                              <span *ngIf="data.editable" class="material-icons close p-10 cp fs-20" (click)="cancelEdit(data)">close</span>
                              <span *ngIf="data.editable" class="material-icons link p-10 cp fs-20" (click)="saveAddNewCategory(data)">check</span>
                            </ng-container>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </div>
  </div>
</ion-content>
